import React, {Component} from "react";
import CustodiaTitulosMantView from "./CustodiaTitulosMantView";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {Growl} from "primereact/growl";
import {Checkbox} from 'primereact/checkbox';
import {CustodyTitlesService} from "../../../service/operation/custodyTitles/CustodyTitlesService";
import {CatalogService} from "../../../service/catalog/CatalogService";

export default class CustodiaTitulosMantContainer extends Component {
    constructor(props) {
        super(props);
        this.custodyService = new CustodyTitlesService();
        this.institutionService = new CatalogService();
        this.setConfirmationRefSave = element => {
            this.confirmationRefSave = element
        };
        this.state = {
            isLoading: false,
            dataInstitutions: [],
            dataInstitutionsMap:{},
        };
        this.getAutomaticInstitutions = this.getAutomaticInstitutions.bind(this);
        this.automaticTemplate = this.automaticTemplate.bind(this);
        this.saveDataInstitutions = this.saveDataInstitutions.bind(this);
        this.openConfMsgSaveInst = this.openConfMsgSaveInst.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    componentDidMount() {
        this.getAutomaticInstitutions();
    }

    getAutomaticInstitutions(){
        this.loading(true);

        this.institutionService.getCatalogInstitutionByRol(2).then(res =>{
            let dataInstLegacy = res.map(function (elem){
                elem['automatic'] = false;
                return elem;
            });
            this.setState({dataInstitutions: dataInstLegacy});

            this.custodyService.getAutomaticLender().then(resAtm =>{
                let dataInstAux = this.state.dataInstitutions;
                let institutionMap = new Map();

                resAtm.forEach(inst => {
                    let atmInst = dataInstAux.find(elem => elem['idInstitucion'] === inst['institutionId']);
                    if (atmInst !== undefined){
                        let indexAtmInst = dataInstAux.indexOf(atmInst);
                        atmInst['automatic'] = true;
                        dataInstAux.splice(indexAtmInst, 1, atmInst);
                    }
                })
                dataInstAux.forEach(inst =>  institutionMap.set(inst.idInstitucion, inst));
                this.setState({
                    dataInstitutions: dataInstAux,
                    dataInstitutionsMap: institutionMap,
                });
                this.loading(false);
            })
        });
    }

    saveDataInstitutions(){
        this.loading(true);
        let automaticLenderDtoList = this.state.dataInstitutions.map(function (elem){
            let automaticLenderDTO = {
                institutionId: elem.idInstitucion,
                automatic: elem.automatic
            }
            return automaticLenderDTO;
        });
        this.custodyService.updateAutomatic(automaticLenderDtoList).then(resp => {
            if (resp.success === false) {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'Error al guardar.'
                });
            } else {
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: 'Se ha guardado su solicitud con éxito.'
                });
            }
            this.getAutomaticInstitutions();
            this.loading(false);
        });
    }

    openConfMsgSaveInst() {
        if (this.confirmationRefSave) {
            this.confirmationRefSave.openConfirmationMessage();
        }
    }

    onChangeAutomaticCheck(rowData) {
        let instMap = this.state.dataInstitutionsMap;
        let mapElem = instMap.get(rowData.idInstitucion);
        mapElem['automatic'] = !mapElem['automatic'];
        this.setState({
            dataInstitutions: Array.from(instMap.values()),
        });
    }

    automaticTemplate(rowData){
        return <Checkbox inputId="binary" checked={rowData['automatic']}
                         onChange={()=>this.onChangeAutomaticCheck(rowData)}/>
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsgSave = <ConfirmationMessage ref={this.setConfirmationRefSave}
                                                invisible={true}
                                                legend="¿Está seguro que desea guardar los cambios?"
                                                action={this.saveDataInstitutions}/>;
        return <CustodiaTitulosMantView
            isLoading={this.state.isLoading}
            dataInstitutions={this.state.dataInstitutions}
            messagesGrowl={messagesGrowl}
            confMsgSave={this.confMsgSave}
            automaticTemplate={this.automaticTemplate}
            openConfMsgSaveInst={this.openConfMsgSaveInst}
        />
    }
}